import React from "react";
import { Modal, Button, Card } from "react-bootstrap";
import { useUser } from "../../../context/UserContext";

const SetupModal = ({ show, handleClose, onSetupClick }) => {
  const { user } = useUser();
  const displayName = user?.first_name || "User";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title className="fs-three">Guided Set-up</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Card className="py-4 px-0 mt-3 border-light-subtle rounded-4 bg-light-subtle">
          <h6 className="text-center fw-bold fs-three mb-0">
            {displayName && `Hey, ${displayName} `}
            <img
              src="/assets/waving-hand.svg"
              alt="Right Icon"
              className="me-1"
            />
          </h6>
          <h3 className="text-center gray-color fs-two-title fw-bold py-4">
            Welcome to Nouraa!
          </h3>

          <p className="text-center fw-bold border-top border-light-subtle pt-4 mb-0">
            Let’s set up Nouraa to answer your callers in four easy steps!
          </p>

          <div className="row mt-4">
            <div className="col-md-6 mb-3">
              <Card className="p-4 border-light-subtle ms-4 rounded-3">
                <div className="d-flex">
                  <div className="bg-icon bg-width p-3 fw-bold purple-color me-3 fs-three-title">
                    <span className="d-flex justify-content-center fs-three">
                      1
                    </span>
                  </div>
                  <div>
                    <h6 className="fw-bold fs-three">Personalize Nouraa</h6>
                    <p className="text-muted mb-0">
                      Teach Nouraa about your business to enhance customer
                      interactions.
                    </p>
                  </div>
                </div>
              </Card>
            </div>
            <div className="col-md-6 mb-3">
              <Card className="p-4  me-4 border-light-subtle rounded-3">
                <div className="d-flex">
                  <div className="bg-icon bg-width p-3 fw-bold purple-color me-3 fs-three-title">
                    <span className="d-flex justify-content-center fs-three">
                      2
                    </span>
                  </div>
                  <div>
                    <h6 className="fw-bold fs-three">Define Call Handling</h6>
                    <p className="text-muted mb-0">
                      Add instructions on how Nouraa should manage calls and
                      responses.
                    </p>
                  </div>
                </div>
              </Card>
            </div>
            <div className="col-md-6 mb-3">
              <Card className="p-4 border-light-subtle ms-4 rounded-3">
                <div className="d-flex">
                  <div className="bg-icon bg-width p-3 fw-bold purple-color me-3 fs-three-title">
                    <span className="d-flex justify-content-center fs-three">
                      3
                    </span>
                  </div>
                  <div>
                    <h6 className="fw-bold fs-three">Test Nouraa</h6>
                    <p className="text-muted mb-0">
                      Try Nouraa with your custom settings and optimize the
                      experience.
                    </p>
                  </div>
                </div>
              </Card>
            </div>
            <div className="col-md-6 mb-3">
              <Card className="p-4 me-4 border-light-subtle rounded-3">
                <div className="d-flex ">
                  <div className="bg-icon bg-width p-3 fw-bold purple-color me-3 fs-three-title">
                    <span className="d-flex justify-content-center fs-three">
                      4
                    </span>
                  </div>
                  <div>
                    <h6 className="fw-bold fs-three">Launch</h6>
                    <p className="text-muted mb-0">
                      Link a phone number so Nouraa can start handling your
                      business calls.
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
          <Button
            variant="none"
            onClick={onSetupClick}
            className="w-25 mx-auto fw-bold my-3 btn-primary-style"
          >
            Let’s Setup
          </Button>
        </Card>
      </Modal.Body>
      <Modal.Footer className="pb-5"></Modal.Footer>
    </Modal>
  );
};

export default SetupModal;
